import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initTelemetry } from './utils/telemetry'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

// Errors go to the backend, which forwards them to Cloud Logging and Error
// Reporting under its own service account. Nothing to configure and no DSN —
// see src/utils/telemetry.ts.
initTelemetry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
